<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Ubicaciones físicas de la empresa. Pueden almacenar,
                producir o distribuir; se relacionan con almacenes y 
                ubicaciones internas. Úsalo para dar de alta una planta,
                actualizar su dirección y vincular su inventario.</p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Plantas
          </h2>
        </div>

        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina las <b>plantas</b> que operan dentro de AVE.
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
                  <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]"
            [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Plantas</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'" (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
          <!-- Add button (only icon) -->
          <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
              [trackBy]="trackByFn">
              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                <td mat-cell *matCellDef="let plant" class="text-sm uppercase leading-tight">
                  <div *ngIf="getCode(plant) as code">
                    <b class="f-10">{{ code }}</b>
                  </div>
                  {{ plant.name }}
                </td>
              </ng-container>
  
              <!-- Estado -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
                <td mat-cell *matCellDef="let plant" class="px-6 text-left">
                  <mat-slide-toggle class="custom-slide-toggle primary" [checked]="plant.statusId == 1"
                    [(ngModel)]="plant.statusId" [color]="'success'" (ngModelChange)="onStatusChange($event, plant)">
                  </mat-slide-toggle>
                </td>
              </ng-container>
  
              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let plant" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(plant)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(plant)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
  
              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
  
              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
            </table>
          </div>
        </div>
  
        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>
  
      <!-- Modales -->
      <ng-template #addModal>
        <h2 mat-dialog-title class="text-lg font-bold pb-4 border-b border-gray-200 dark:border-gray-700">Nuevo Registro</h2>
        <mat-dialog-content>
          <form #createForm="ngForm">
            <app-form-section
              title="Información Básica"
              icon="location_city"
              color="blue"
              class="space-y-4">
              <div class="space-y-4">
                <div class="grid grid-cols-2 gap-4">
                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Código</mat-label>
                    <input matInput [(ngModel)]="currentCreatePlant.code" name="code" required>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Nombre</mat-label>
                    <input matInput [(ngModel)]="currentCreatePlant.name" name="name" required>
                  </mat-form-field>
                </div>
                <!-- Select Compañía -->
                <div class="w-full">
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Compañía</label>
                  <ng-select
                    [(ngModel)]="currentCreatePlant.companyId"
                    [items]="companyList"
                    bindLabel="name"
                    bindValue="_id"
                    [multiple]="true"
                    [searchable]="true"
                    placeholder="Seleccione una compañía"
                    name="companyId"
                    [appendTo]="'body'"
                    required
                  >
                  </ng-select>
                </div>
              </div>
            </app-form-section>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="flex justify-end pt-4 border-t border-gray-200 dark:border-gray-700">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button
            mat-raised-button color="primary"
            (click)="createPlant()"
            [disabled]="!createForm.valid">Guardar</button>
          </mat-dialog-actions>
        </ng-template>
        
      <!-- Modal Editar -->
      <ng-template #editModal>
        <h2 mat-dialog-title class="text-lg font-bold pb-4 border-b border-gray-200 dark:border-gray-700">Editar Registro</h2>
        <mat-dialog-content>
          <form #editForm="ngForm">
            <app-form-section
              title="Información Básica"
              icon="location_city"
              color="blue"
              class="space-y-4">
              <div class="space-y-4">
                <div class="grid grid-cols-2 gap-4">
                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Código</mat-label>
                    <input matInput [(ngModel)]="currentUpdatePlant.externalKeys.code" name="code" disabled>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Nombre</mat-label>
                    <input matInput [(ngModel)]="currentUpdatePlant.name" name="name" required>
                  </mat-form-field>
                </div>
                <!-- Select Compañía -->
                <div class="w-full">
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Compañía</label>
                  <ng-select
                    [(ngModel)]="currentUpdatePlant.company"
                    [items]="companyList"
                    bindLabel="name"
                    bindValue="_id"
                    [searchable]="true"
                    placeholder="Seleccione una compañía"
                    name="companyId"
                    [multiple]="true"
                    [compareWith]="compareById"
                    (ngModelChange)="onCompanySelectionChange($event)"
                    [appendTo]="'body'"
                    required
                  >
                  </ng-select>
                </div>
              </div>
            </app-form-section>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="flex justify-end pt-4 border-t border-gray-200 dark:border-gray-700">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button
            mat-raised-button color="primary"
            (click)="updatePlant(currentUpdatePlant._id)"
            [disabled]="!editForm.valid">Guardar</button>
          </mat-dialog-actions>
        </ng-template>
  
      <ng-template #deleteDialog let-data>
        <div class="flex items-start space-x-2 mb-4">
          <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
              style="font-size: 32px;"></mat-icon>
          </div>
          <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
            <mat-dialog-content class="modal-content mt-0">
              <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
          </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Conservar</button>
          <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
        </mat-dialog-actions>
      </ng-template>
    </div>
    <!-- Filtros -->
  <app-filter
    (onFilterEvent)="findAllWithCount()"
    (onCleanEvent)="clearFilters()"
    (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters
      [form]="form"
      [company]="true"
      [loadData]="loadFiltersData"></app-configuration-filters>
  </app-filter>
</mat-sidenav-container>
  